import { BaseURI } from "../..";
import { Executor } from "../../Executor";

export const getTagLogs = (id, page, limit, searchTerm, eventType, unauthorizedOnly) => {
  // Create query parameters dynamically
  const params = new URLSearchParams({
    page,
    limit,
  });

  if (searchTerm) {
    params.append("search", searchTerm);
  }

  if (eventType && eventType !== "All") {
    params.append("eventType", eventType);
  }

  if (unauthorizedOnly) {
    params.append("unauthorized", "true");
  }

  return Executor({
    method: "get",
    url: `${BaseURI}/api/redear/TagMouvement/${id}?${params.toString()}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

